export var ts;
export function init(modules) {
  ts = modules.typescript;
}
